<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    mobile-breakpoint="960"
    app
    mini-variant-width="80"
    width="260"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      />
    </template>

    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="text-uppercase font-weight-regular display-2">
          <span class="logo-mini">{{ $t('ct') }}</span>
          <span class="logo-normal">{{ $t('tim') }}</span>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider class="mb-1" />

    <v-list
      dense
      nav
    >
      <base-item-group :item="profile" />
    </v-list>

    <v-divider class="mb-2" />

    <v-list
      expand
      nav
    >
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in computedItems">
        <base-item-group
          v-if="isMenuParentVisible(item)"
          :key="`group-${i}`"
          :item="item"
        >
          <!--  -->
        </base-item-group>

        <base-item
          v-if="isMenuVisible(item)"
          :key="`item-${i}`"
          :item="item"
        />
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>
  </v-navigation-drawer>
</template>
<style>
.v-navigation-drawer__content{
  background-color: #072347;
}
</style>
<script>
  // Utilities
  import {
    mapState,
  } from 'vuex'
  import { repositoryFactory } from '@/api/repositoryFactory'
  const targetRespository = repositoryFactory.get('targets')

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      items: [
        {
          icon: 'mdi-view-dashboard',
          title: 'dashboard',
          to: '/',
          roles: ['Admin', 'Monitor'],
        },
        {
          group: '',
          icon: 'mdi-octagon',
          title: 'tanks',
          type: 'TA',
          roles: ['Admin'],
          children: [
            {
              title: 'sensors',
              to: 'targets/tanks',
            },
            {
              group: '',
              title: 'reports',
              children: [
                {
                  title: 'tankRangeDateReport',
                  to: 'reports/tank/rangeDateReport',
                },
              ],
            },
          ],
        },
        {
          group: '',
          icon: 'mdi-coolant-temperature',
          title: 'temperatures',
          type: 'TE',
          roles: ['Admin'],
          children: [
            {
              title: 'sensors',
              to: 'targets/temperatures',
            },
            {
              group: '',
              title: 'reports',
              children: [
                {
                  title: 'temperatureRangeDateReport',
                  to: 'reports/temperature/rangeDateReport',
                },
                {
                  title: 'compliceTemperatureReport',
                  to: 'reports/temperature/compliceTemperature',
                },
              ],
            },
          ],
        },
        {
          icon: 'mdi-account-alert',
          title: 'contacts',
          to: '/contacts/contactList',
          roles: ['Admin'],
        },
        {
          icon: 'mdi-account',
          title: 'users',
          to: '/users/userList',
          roles: ['Admin'],
        },
      ],
      targetTypes: [],
    }),

    computed: {
      ...mapState(['barColor', 'barImage']),
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },
      computedItems () {
        return this.items.map(this.mapItem)
      },
      profile () {
        return {
          avatar: true,
          group: '',
          title: this.$store.state.user ? this.$store.state.user.userName : '',
          children: [
            // {
            //   href: '',
            //   title: this.$t('my-profile'),
            // },
            // {
            //   to: '',
            //   title: this.$t('edit-profile'),
            // },
            // {
            //   to: '',
            //   title: this.$t('settings'),
            // },
          ],
        }
      },
    },

    watch: {
      '$vuetify.breakpoint.smAndDown' (val) {
        this.$emit('update:expandOnHover', !val)
      },
    },
    mounted () {
      this.getTargetTypes()
    },
    methods: {
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title),
        }
      },
      isMenuVisible (item) {
        return !item.children && this.isInRole(item) === true && (!item.type || (item.type && this.targetTypes.indexOf(item.type) > -1))
      },
      isMenuParentVisible (item) {
        return item.children && this.isInRole(item) === true && (!item.type || (item.type && this.targetTypes.indexOf(item.type) > -1))
      },
      getTargetTypes () {
        var self = this
        targetRespository.getTypesForMenu().then(response => {
          self.targetTypes = response.data.data
          // self.loadingTargets = false
        }).catch(err => {
          self.loadingTargets = false
          self.showErrorMessage = true
          self.errorMessage = err
        })
      },
      isInRole (item) {
        var isInRole = false
        var user = JSON.parse(window.localStorage.getItem('user'))
        user.roles.forEach(role => {
          // this.$store.state.user.roles.forEach(role => {
          item.roles.forEach(roleMenu => {
            if (role.name === roleMenu) {
              isInRole = true
            }
          })
        })
        return isInRole
      },
    },
  }
</script>
<style lang="sass">

  #core-navigation-drawer
    &.v-navigation-drawer--mini-variant
      .v-list-item
        justify-content: flex-start !important

      .v-list-group--sub-group
        display: block !important

    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
